import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/vuex';
import axios from 'axios';
import VueAxios from 'vue-axios';

import './assets/css/_avatar.scss';
import './assets/css/_button.scss';
import './assets/css/_close-button.scss';
import './assets/css/_external.scss';
import './assets/css/_hover-menu.scss';
import './assets/css/_input.scss';
import './assets/css/_popup.scss';
import './assets/css/_scrollable-list.scss';
import './assets/css/_spin.scss';
import './assets/css/_utils.scss';
import './assets/css/_variables.scss';
// perfectscrollbar
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import { ToastOptions } from 'vue-toastification/dist/types/src/types';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

// toast
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const options: ToastOptions = {
  // You can set your default options here
  position: POSITION.TOP_CENTER,
};
Vue.config.productionTip = false;
Vue.use(Toast, options);
Vue.use(DatePicker as any);
Vue.use(PerfectScrollbar);

// axios
Vue.use(VueAxios, axios);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
